import { i18n } from "translate/i18n";

export const textCopied = i18n.t("messages.textCopied");
